import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UpdateUser } from '../../../queries/users.model';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { UserService } from '../../../shared/services/user.service';
import { AuthService } from '../../../shared/services/auth.service';
import { ArtistSearchService } from '../../../shared/services/artist-search.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Constants } from '../../../helpers/constants';

@Component({
  selector: 'my-user-form-edit',
  template: require('./user-form-edit.component.html'),
  styles: [require('./user-edit.component.scss')]
})

export class UserFormEditComponent implements OnInit, OnDestroy, AfterViewInit {
  public clientRole = ['Affiliate Label', 'Artist Manager', 'Artist', 'Other'];
  public userType = ['External VIP', 'External Restricted'];
  public oktaTenent = ['GLOBAL', 'BRANDED'];
  public tenant: any;
  public type;
  public role;
  public config: object;
  public individualArtist: boolean;
  public revenueAccess: boolean;
  public discoverAccess: boolean;
  public enableRevenueAccess: boolean = false;
  public enableUmdAccessToggle: boolean = false;
  public strRoleSelected: string = '';
  public strUserTypeSelected: string = '';
  public userUpdate: any = {};
  public artistExists: boolean;
  public swiftConsumptionAppObj: object;
  public userPhoneNumber: '';
  public userFirstName: '';
  public userEmail: '';
  public userCountry = '';
  public artists: any = [];
  public userCompany: '';
  public defaultLabel = '';
  public userLastName: '';
  public flHidden: boolean;
  public iaHidden: boolean;
  public userLastAccessed: any;
  public revokedDate: string = '';
  public defaultLabels = '';
  public defaultLabelList: any;
  public subLabels: any;
  public subLabelsList: any = [];
  public showSubLabelsList: Boolean = false;
  public countryList: [''];
  public originalDefaultLabels: any;
  public originalCountriesList: any;
  public submitted: Boolean;
  public userExists: Boolean;
  public dizzeeTenant;
  public error: '';
  public user;
  public selectedArtist = [];
  public isArtistOrLabelSelected: boolean;
  public artistSelected: boolean;
  public isArtistSelected: boolean;
  public keyUp = new Subject<string>();
  public QueensCatalogue: any;
  public updateUserSub: Subscription;
  public updateUserForm: FormGroup;
  public userCreatedBy: string;

  @ViewChild('lgModal') public lgModal: ModalDirective;
  @ViewChild('smModal') public smModal: ModalDirective;
  @Output() edited: EventEmitter<string> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private searchService: ArtistSearchService) {
    this.keyUp
      .map((value) => value)
      .debounceTime(500)
      .distinctUntilChanged()
      .flatMap((search) => {
        return Observable.of(search).delay(500);
      })
      .subscribe((term) => this.search(term));
  };

  search(term) {
    // console.log('New user artist search', term);
    let tempData;
    if (_.trimStart(term, ' ').length === 0) {
      return;
    }
    this.searchService.searchArtist(term).subscribe(
      (res) => {
        // console.log(res);
        tempData = res;
      },
      (err) => console.log(err),
      () => {
        this.artists = tempData.searchArtists;
        // console.log(this.artists);
      });
  }

  addArtist(artist) {
    let isAlreadyArtistSelected = _.some(this.selectedArtist, function (obj) {
      // console.log('artist obj', obj);
      return obj._id === artist._id;
    });
    if (isAlreadyArtistSelected) {
      // console.log('Artist already selected');
      this.artistExists = true;
    } else {
      this.artistExists = false;
      let newArtist = { _id: artist._id, name: artist.name, image: artist.image };
      this.selectedArtist.push(newArtist);
    }
    // console.log(this.selectedArtist);
  }

  selectedRole(role: any) {
    // console.log('selected role', role);
    this.strRoleSelected = role;
    switch (role) {
      case 'Affiliate Label':
        this.flHidden = false;
        this.iaHidden = true;
        this.showSubLabelsList = true;
        this.userType = ['External VIP', 'External Restricted'];
        this.updateUserForm.controls['defaultLabels'].patchValue('', { onlySelf: true });
        break;
      case 'Other':
        this.flHidden = false;
        this.iaHidden = false;
        this.showSubLabelsList = false;
        this.userType = ['External VIP', 'External Restricted'];
        this.updateUserForm.controls['defaultLabels'].patchValue('', { onlySelf: true });
        break;

      case 'Artist Manager':
      case 'Artist':
      default:
        this.flHidden = true;
        this.iaHidden = false;
        this.showSubLabelsList = false;
        this.defaultLabels = '';
        this.type = '';
        this.userType = ['External Restricted'];
        this.updateUserForm.controls['type'].patchValue(this.type, { onlySelf: true });

        this.updateUserForm.controls['defaultLabels'].patchValue('', { onlySelf: true });
        break;
    }
  }

  selectedFl(fl: string) {
    this.updateUserForm.controls['subLabels'].patchValue('', { onlySelf: true });

    let tempData;
    this.userService.getSubLabels(fl).subscribe(
      (res) => {
        tempData = res;
      },
      (err) => {
        console.log(err);
      }, () => {
        this.subLabelsList = tempData.getSubLabels;
      });

    let i = this.userService.externalVip.indexOf(fl);
    if (i !== -1) {
      this.userType = ['External VIP', 'External Restricted'];
      this.isArtistOrLabelSelected = false;
    } else {
      this.userType = ['External Restricted'];
      this.isArtistOrLabelSelected = false;
      this.updateUserForm.controls['type'].patchValue('', { onlySelf: true });
    }
  }

  selectedUserType(userType: any) {
    this.strUserTypeSelected = userType;
    this.validateRevenueAccess();
  }

  validateRevenueAccess() {
    if ((this.strRoleSelected === 'Affiliate Label' || this.strRoleSelected === 'Other') &&
      (this.strUserTypeSelected === 'External Restricted') && this.authService.userLoginType === 'admin') {
      this.enableRevenueAccess = true;
    } else {
      this.enableRevenueAccess = false;
    }
  }

  umdAccessToggle(e: any) {
    if (e.target.checked && (this.isArtistOrLabelSelected || this.isArtistSelected)) {
      this.isArtistOrLabelSelected = false;
      this.isArtistSelected = false;
    }
  }

  ngAfterViewInit() {
    this.lgModal.show();
  }


  formatDate(d) {
    return d === null ? 'Never' : moment(d).format('MMMM Do YYYY, h:mm:ss a');
  }


  validatePhone(c: FormControl) {
    // accept a number that's at least 10 digits and up to 15
    /* tslint:disable */
    let PHONE_REGEXP = new RegExp('^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})$');
    return PHONE_REGEXP.test(c.value) ? null : {
      validatePhone: {
        valid: false
      }
    };
  }

  validateEmail(c: FormControl) {
    /* tslint:disable */
    let EMAIL_REGEXP = new RegExp('/^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/');
    /* tslint:enable */
    return EMAIL_REGEXP.test(c.value) ? null : {
      validateEmail: {
        valid: false
      }
    };
  }

  accessDisabled() {
    return this.userService.isValid;
  }

  bmUser() {
    return this.tenant === 'bm';
  }

  previousModal() {
    this.smModal.hide();
    this.lgModal.show();
  }

  cancelForm() {
    if (this.lgModal.isShown) {
      this.lgModal.hide();
    } else {
      if (this.smModal.isShown) {
        this.smModal.hide();
      }
    }
    this.userService.externalEdit = false;
    this.router.navigateByUrl('external');
  }


  getDefaultLabel(label) {
    let i = _.findIndex(this.originalDefaultLabels, { name: label });
    // console.log('//// i ////', i);
    let d = this.originalDefaultLabels[i];
    // console.log('d: ', d);
    return _.isUndefined(d) || i === -1 ? null
      : {
        name: (d as any).name || '',
        id: (d as any).id || '',
        type: 'Family'
      };
  }

  getCountryObject(country) {
    // console.log('country', country);
    let i = _.findIndex(this.originalCountriesList, { name: country });
    // console.log('//// i ////', i);
    let d = this.originalCountriesList[i];
    // console.log('d: ', d);
    return _.isUndefined(d) || i === -1 ? null
      : {
        name: (d as any).name || '',
        code: (d as any).id || ''
      };
  }

  updateUserQuery(userInput) {
    // console.log('user input inside of update fx()', userInput);
    this.updateUserSub = this.apollo.mutate({
      mutation: UpdateUser,
      variables: {
        ID: this.user._id,
        UserInput: userInput
      }
    })
      .subscribe(() => {
        // this.router.navigate(['/external']);
      }, (error) => {
        // console.log('there was an error sending the query', error.message.split('error'));
        this.error = error.message;
        this.edited.next();
        this.userService.externalEdit = false;
      }, () => {
        // console.log('update user: ', data);
        this.smModal.hide();
        this.submitted = true;
        this.edited.next();
        this.userService.externalEdit = false;
      });

  }


  selectArtistModal() {
    this.lgModal.hide();
    this.smModal.show();
  }

  individualArtistAccess(value) {
    this.artistSelected = false;
    this.updateForm(value);

    if (this.updateUserForm.controls['discoverAccess'].value && !this.updateUserForm.controls['individualArtist'].value) {
      this.updateExistingUser();
      return;
    }
    if (this.updateUserForm.controls['role'].value === 'Other') {
      if (this.updateUserForm.controls['defaultLabels'].value === '' &&
        !this.updateUserForm.controls['individualArtist'].value) {
        return this.isArtistOrLabelSelected = true;
      } else if (this.updateUserForm.controls['individualArtist'].value) {
        this.isArtistOrLabelSelected = false;
        this.selectArtistModal();
      } else {
        this.updateExistingUser();
      }
    } else if (this.updateUserForm.controls['role'].value === 'Affiliate Label') {
      if (this.updateUserForm.controls['defaultLabels'].value === '') {
        return this.isArtistOrLabelSelected = true;
      } else {
        this.updateExistingUser();
      }
    }
    else if (this.updateUserForm.controls['role'].value === 'Artist Manager' ||
      this.updateUserForm.controls['role'].value === 'Artist') {
      if (this.updateUserForm.controls['individualArtist'].value === false) {
        return this.isArtistSelected = true;
      } else if (this.updateUserForm.controls['individualArtist'].value) {
        this.isArtistSelected = false;
        this.selectArtistModal();
      }
    }
  }

  // move updateForm mutation to user service
  updateForm(value: any): void {
    // event.preventDefault();
    // console.log('value:', value);
    const userInput = {
      internal: false,
      email: value === null ? this.userEmail : value.email,
      firstName: value.firstName === null ? this.userFirstName : value.firstName.charAt(0).toUpperCase() + value.firstName.slice(1),
      lastName: value.lastName === null ? this.userLastName : value.lastName.charAt(0).toUpperCase() + value.lastName.slice(1),
      typeChangedUserId: this.authService.userLoginObject['_id'],
      tenantName: value.dizzeeTenant === 'bm' ? 'BRANDED' : 'GLOBAL',
      info: _.cloneDeep(this.user.info),
      account: {
        config: {
          branding: value.dizzeeTenant ? value.dizzeeTenant : this.tenant,
          appAccess: null
        }
      },
      applications: _.cloneDeep(this.user.applications),
      discoverAccess: false
    };
    // KFK HAS SAID NO INTERNAL USER DATA UPDATES BUT HERE IS THE ENTRY JUST IN CASE

    userInput.info.phoneNumber = value.phoneNumber === null ? this.userPhoneNumber.toString() : value.phoneNumber.toString();
    userInput.info.company = value.company === null ? this.userCompany : value.company;
    userInput.info.country = value.country === null ? this.getCountryObject(this.userCountry) : this.getCountryObject(value.country);
    userInput.info.clientRole = value.role === null ? this.role : value.role;



    let applications = _.find(userInput.applications, (app) => {
      return app['name'] === Constants.EXTAPPNAME;
    });

    if (applications === undefined) {
      userInput.applications.push({ name: Constants.EXTAPPNAME }, { name: Constants.EXTAPPTRENDS });
    }

    userInput.applications.map((app) => {
      // if(app.name === Constants.EXTAPPNAME) {
      app.userType = value.type === null ? this.type : value.type;
      app.accessArtists = [];
      app.defaultLabel = value.defaultLabels ? this.getDefaultLabel(value.defaultLabels) : null;
      app.r2SubLabels = value.subLabels ? value.subLabels : [];
      app.revenueAccess = {
        canView: this.enableRevenueAccess ? value.revenueAccess ? true : false : false,
      }
      if (app.revenueAccess.canView) {
        app.revenueAccess.adminGrantedAccess = this.authService.userLoginType === 'admin' ? true : false,
          app.revenueAccess.adminOid = this.authService.userLoginObject['_id'],
          app.revenueAccess.adminEmail = this.authService.userLoginObject['email']
      }
      // }
    });
    userInput.discoverAccess = value.discoverAccess ? value.discoverAccess : false;
    this.userUpdate = userInput;
  }

  updateExistingUser() {
    // if(this.selectedArtist.length) {
    this.artistSelected = false;
    this.userUpdate.applications.map((app) => {
      // if(app.name === Constants.EXTAPPNAME) {
      app.accessArtists = this.selectedArtist;
      // }
    });
    this.updateUserQuery(this.userUpdate);
  }

  removeFilter(i) {
    this.selectedArtist.splice(i, 1);
  }

  ngOnInit() {
    // To set Modal to static

    this.config = {
      backdrop: 'static',
      keyboard: false,
      animated: false
    };

    this.artistExists = false;
    this.artistSelected = false;
    this.isArtistSelected = false;
    this.isArtistOrLabelSelected = false;
    this.user = this.userService.getExternalUser();
    this.userLastAccessed = this.user.lastAccessed;
    this.revokedDate = this.user.revokedDate;
    this.userEmail = this.user.email ? this.user.email : '';
    this.userFirstName = this.user.firstName ? this.user.firstName : '';
    this.userCreatedBy = this.user.createdUser && this.user.createdUser.email ? this.user.createdUser.email : '';
    this.userLastName = this.user.lastName ? this.user.lastName : '';
    this.userPhoneNumber = this.user.info.phoneNumber ? this.user.info.phoneNumber : '';
    this.userCountry = this.user.info ? this.user.info.country.name : '';
    this.userCompany = this.user.info.company ? this.user.info.company : '';
    this.role = this.user.info.clientRole ? this.user.info.clientRole : '';
    this.tenant = this.user.account && this.user.account.config && this.user.account.config.branding ?
      this.user.account.config.branding : 'default';
    if (this.role === 'Affiliate Label' || this.role === 'Other') {
      this.flHidden = false;
    } else {
      this.flHidden = true;
    }
    this.user.applications.map((app) => {
      if (app.name === Constants.EXTAPPNAME) {
        this.swiftConsumptionAppObj = app;
        // console.log('app consumption', app);
        this.type = app.userType ? app.userType : '';
        this.defaultLabels = app.defaultLabel ? app.defaultLabel.name : '';
        this.subLabels = app.r2SubLabels ? app.r2SubLabels : '';
        this.selectedArtist = app.accessArtists ? app.accessArtists : [];
        this.revenueAccess = app.revenueAccess.canView ? app.revenueAccess.canView : false;
      }
    });
    if (this.role === 'Affiliate Label') {
      this.iaHidden = true;
      this.showSubLabelsList = true;
      let tempData;
      this.userService.getSubLabels(this.defaultLabels).subscribe(
        (res) => {
          tempData = res;
        },
        (err) => {
          console.log(err);
        }, () => {
          this.subLabelsList = tempData.getSubLabels;
        });
    } else {
      this.iaHidden = false;
    }
    this.strRoleSelected = this.role;
    this.strUserTypeSelected = this.type;
    this.validateRevenueAccess();
    this.discoverAccess = this.user.discoverAccess ? this.user.discoverAccess : false;
    this.enableUmdAccessToggle = this.authService.userLoginType === 'admin' ? true : false;
    this.selectedArtist = this.selectedArtist.map((artist) => {
      return {
        _id: artist._id,
        name: artist.name,
        image: artist.image
      };
    });
    if (this.selectedArtist.length) {
      this.individualArtist = true;
    }
    this.submitted = false;
    this.error = '';
    this.userExists = false;
    this.lgModal.isAnimated = false;


    // this.userService.getDefaultLabels().subscribe(() => {
    this.originalDefaultLabels = this.userService.originalDefaultLabels.labels;
    this.defaultLabelList = this.originalDefaultLabels.map((label) => {
      return label.name;
    });

    // GRAB COUNTRIES FROM METADATA DB
    this.originalCountriesList = this.userService.countryList.countries;
    this.countryList = this.originalCountriesList.map((country) => {
      return country.name;
    });


    // build reactive form model
    this.updateUserForm = this.formBuilder.group({
      firstName: [this.userFirstName, Validators.required],
      lastName: [this.userLastName, Validators.required],
      email: new FormControl(this.userEmail, [Validators.required, this.validateEmail]),
      company: [this.userCompany, Validators.required],
      phoneNumber: new FormControl(this.userPhoneNumber),
      country: new FormControl(this.userCountry, [Validators.required]),
      individualArtist: new FormControl(this.individualArtist),
      revenueAccess: new FormControl(this.revenueAccess),
      discoverAccess: new FormControl(this.discoverAccess),
      type: new FormControl(this.type, [Validators.required]),
      role: new FormControl(this.role, [Validators.required]),
      defaultLabels: new FormControl(this.defaultLabels, [Validators.required]),
      subLabels: new FormControl(this.subLabels),
      dizzeeTenant: new FormControl(this.tenant)
    });

    // set defaultLabel on reactive form after observable load

    (<FormControl>this.updateUserForm.controls['defaultLabels'])
      .setValue(this.defaultLabels, { onlySelf: true });

    // set country on reactive form after observable loads

    (<FormControl>this.updateUserForm.controls['country'])
      .setValue(this.userCountry, { onlySelf: true });


  }




  ngOnDestroy() {
    this.submitted = false;
    this.error = '';
    this.userExists = false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/users/user-form/user-form-edit/user-form-edit.component.ts